import * as Yup from 'yup';
import './cpfMethodValidation';

export const associatesAndProposalsValidation = Yup.object().shape({
  nameInput: Yup.string().nullable().required('Nome é obrigatório'),
  cpfInput: Yup.string().cpfType('Digite um CPF válido').nullable(),
  birthdayInput: Yup.date()
    .nullable()
    .required('Data de nascimento é obrigatório'),
  phoneInput: Yup.string().nullable().required('Celular é obrigatório'),
  zipInput: Yup.string().nullable().required('CEP é obrigatório'),
  streetInput: Yup.string().nullable().required('Logradouro é obrigatório'),
  numberInput: Yup.string().nullable().required('Número é obrigatório'),
  neighborhoodInput: Yup.string().nullable().required('Bairro é obrigatório'),
  cityInput: Yup.object().nullable().required('Cidade é obrigatório'),
  rgInput: Yup.string().nullable(),
  orgaoInput: Yup.string().nullable(),
  genderInput: Yup.string().nullable().required('Gênero é obrigatório'),
  stateCivilInput: Yup.object().nullable(),
  jobInput: Yup.string().nullable(),
  obsInput: Yup.string().nullable(),
  emailInput: Yup.string().nullable(),
  telInput: Yup.string().nullable(),
  whatsappInput: Yup.string().nullable(),
  canSendMessageSelect: Yup.boolean().nullable(),
  address2Input: Yup.string().nullable(),
  pointInput: Yup.string().nullable(),
  isActiveSelect: Yup.boolean().nullable(),
  isDiedSelect: Yup.boolean().nullable(),
  motherName: Yup.string().nullable(),
});
